import { useBreakpointIndex } from '@apia/theme';
import React from 'react';
import usePortal from 'react-cool-portal';
import { FavoriteIcon } from '../FavoriteIcon';

export const CenteredHeaderButtons = () => {
  const breakpoint = useBreakpointIndex({ defaultIndex: 4 });

  const { Portal: Portal1 } = usePortal({
    autoRemoveContainer: false,
    clickOutsideToHide: false,
    containerId: 'ResponsiveButtons',
    defaultShow: true,
    escToHide: false,
    internalShowHide: true,
  });
  const { Portal: Portal2 } = usePortal({
    autoRemoveContainer: false,
    clickOutsideToHide: false,
    containerId: 'HamburguerIconWrapper',
    defaultShow: true,
    escToHide: false,
    internalShowHide: true,
  });
  const { Portal: Portal3 } = usePortal({
    autoRemoveContainer: false,
    clickOutsideToHide: false,
    containerId: 'RelatedButtonsContainer',
    defaultShow: true,
    escToHide: false,
    internalShowHide: true,
  });

  const icon = React.useMemo(() => <FavoriteIcon />, []);

  if (breakpoint < 3) return <Portal1>{icon}</Portal1>;
  if (breakpoint === 3) return <Portal2>{icon}</Portal2>;
  return <Portal3>{icon}</Portal3>;
};
